import * as types from '../constants/actionTypes';

export function selectMonth(value) {
  return {
    type: types.SELECT_MONTH,
    value
  };
}

export function selectNextMonth() {
  return {
    type: types.SELECT_NEXT_MONTH
  };
}

export function selectPreviousMonth() {
  return {
    type: types.SELECT_PREVIOUS_MONTH
  };
}

export function displayInfobox(value) {
  return {
    type: types.DISPLAY_INFOBOX,
    value
  };
}

export function hideInfobox() {
  return {
    type: types.HIDE_INFOBOX,
    value: false
  };
}

export function showSelection() {
  return {
    type: types.SHOW_SELECTION,
    value: true
  };
}

export function hideSelection() {
  return {
    type: types.HIDE_SELECTION,
    value: false
  };
}

export function addAreaToSelection(value) {
  return {
    type: types.ADD_AREA_TO_SELECTION,
    value: value
  };
}

export function removeAreaFromSelection(value) {
  return {
    type: types.REMOVE_AREA_FROM_SELECTION,
    value: value
  };
}

export function removeAllAreasFromSelection() {
  return {
    type: types.REMOVE_ALL_AREAS_FROM_SELECTION
  };
}

export function hidePromo() {
  return {
    type: types.HIDE_PROMO
  };
}




/** WEBPACK FOOTER **
 ** ./src/actions/selectionActions.js
 **/